import styled from "styled-components";
import { size, scarpaGray700 } from "../../StylesConstants";

const OverlayWrapper = styled.div`
  .overlay {
    height: 0%;
    width: 100%;
    position: fixed;
    z-index: 10000;
    top: 0;
    left: 0;
    background-color: white;
    overflow-y: auto;
    transition: 0.5s;

    .container-call {
      display: flex;
      justify-content: center;
    }
  }

  .overlay-open {
    width: 100% !important;
    height: 100% !important;
  }

  .overlay-close {
    width: 0% !important;
    height: 0% !important;
  }

  .header {
    display: grid;
    grid-template-columns: 1fr;
    padding: 14px 16px;
    .logo-overlay {
      justify-self: baseline;
    }

    .close-overlay {
      justify-self: end;
    }
  }

  .overlay .closebtn {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    text-align: right;
    color: ${scarpaGray700};
  }

  @media screen and (max-height: 450px) {
    .overlay {
      overflow-y: auto;
    }
    .overlay a {
      font-size: 20px;
    }
    .overlay .closebtn {
      font-size: 16px;
      top: 15px;
      right: 35px;
    }
  }

  @media screen and (min-width: ${size.tablet}) {
  }

  @media screen and (min-width: ${size.desktop}) {
  }
`;

export default OverlayWrapper;
